const state = () => ({
    definitionId:'', // 任务流程名称即：process_xxx:xx:xxxx
    deployId:'', // 任务id
    taskName:[], //流程节点信息
    detail:[], // 每条信息的详细数据
    isApprove: 0
})
const getters = {}
const mutations = {
    setDefinitionId(state,value){
        state.definitionId = value
    },
    setDeployId(state,value){
        state.deployId = value
    },
    setTaskName(state,value){
        state.taskName = value
    },
    setDetail(state,value){
        state.detail = value
    },
    setIsApprove(state,value){
        state.isApprove = value
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
